import axios from 'axios';

import store from '@/store/index';
import { AuthTypes } from '@/store/Types';
import { createErrorResult, createSuccessResult } from './ResultContainer';
import { NetworkError } from './NetworkError.js';
import { getAccessToken, fetchAuthorizationCode } from '@/api/auth';

const userHttp = axios.create({
    baseURL: `${process.env.VUE_APP_ACCOUNT_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
    },
    validateStatus(status) {
        /**
         * 405 Method Not Allowed
         * 408 Request Timeout
         * 429 Too Many Requests
         */

        return ![405, 408, 429].includes(status) && status < 500;
    },
});

userHttp.interceptors.response.use(
    (response) => {
        if (response.status >= 400) {
            if (response.status === 401) {
                store.commit(AuthTypes.mutations.ADD_LAST_FAILED_REQUEST, response.config);
                fetchAuthorizationCode().then(() => {});
            }

            return createErrorResult(
                {
                    statusCode: response.status,
                    message: response.data.title ?? response.data ?? response.statusText,
                },
                response
            );
        } else {
            return createSuccessResult(response.data, response);
        }
    },
    (error) => {
        if (!error.response || error.code === 'ECONNABORTED') {
            return Promise.reject(new NetworkError(error.request));
        } else {
            return Promise.reject(error);
        }
    }
);

/*
 * Добавляем токен JWT для всех запросов*/

userHttp.interceptors.request.use(async (config) => {
    return getAccessToken()
        .then(({ token }) => {
            if (config.headers === undefined) {
                config.headers = {};
            }
            config.headers.Authorization = `Bearer ${token?.value}`;
            store.commit(AuthTypes.mutations.ADD_LAST_FAILED_REQUEST, null);
            return Promise.resolve(config);
        })
        .catch(() => {
            console.log('Unable to retrieve access token. Redirecting to auth page');
            store.commit(AuthTypes.mutations.ADD_LAST_FAILED_REQUEST, config);
            return fetchAuthorizationCode();
        });
});

export default userHttp;
